import { render, staticRenderFns } from "./ManageDepartments.vue?vue&type=template&id=5d169db7"
import script from "./ManageDepartments.vue?vue&type=script&lang=js"
export * from "./ManageDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports